import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from "ramda"
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';;
import PageLoader from '../../../../../../components/PageLoader';

import { selectOpenNetworkRegistrationsQueryItems } from '../../../../../../redux/open-network-registrations/selector';
import { openNetworkRegistrations } from '../../../../../../redux/open-network-registrations/action';
import ConfigurationDetails from '../components/setting-details';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import BlacklistedBAPs from '../components/blacklisted-baps';
import WhitelistedRoutes from '../components/whitelisted-routes';
import MaskedKeywords from '../components/masked-keywords';
import ServiceableCities from '../components/serviceable-cities';


const CommerceBppSetting = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const { state } = useLocation();
    const { data } = state ?? {};
    const [selectedTabIndex, setSelectedTabIndex] = React.useState<number | null>(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const dbnpRegistriesQuery = useSelector(selectOpenNetworkRegistrationsQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [ selectedOpenNetworkRegistry, setSelectedOpenNetworkRegistry ] = useState<any>({})

    const onClose = () => {
        navigate(-1)
    }

    const config = {
       "bg_uri": "https://preprod.gateway.ondc.org",
      "bpp_id": "preprod-bpp.dbs.digiit.io",
      "bpp_uri": "https://preprod-bpp.dbs.digiit.io",
      "domain": "ONDC:RET10",
      "port": "3004",
      "core_version": "1.2.0",
      "tenant": "dbs",
      "requester": "https://dbs.opennetwork.digiit.io",
      "store_id": 183,
      "channel_id": 839,
      "channel_name": "opennetwork",
      "email_domain": "supermart.biz",
      "default_user_email": "9878987898@supermart.biz",
      "default_user_phone": "9878987898",
      "account_id": "146",
      "secretkey": "101-b91a2a3b-5e9d-4f57-9e87-ce",
      "ONDC_TOKEN":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTY1OTE1MTk1NiwianRpIjoiMzFjNzQ0Zjg0NWFkNDg5ZmI3NjFlMzRmZDE5NzAxYTkiLCJuYmYiOjE2NTkxNTE5NTYsInR5cGUiOiJhY2Nlc3MiLCJzdWIiOiJicHAuZGJzLmRpZ2lpdC5haUBzZWxsZXIucmV0IiwiZXhwIjoxNzk5MjM4MzU2LCJlbWFpbCI6InRlY2hAb25kYy5vcmciLCJwdXJwb3NlIjoiZGF0YXNoYXJpbmciLCJwaG9uZV9udW1iZXIiOm51bGwsInJvbGVzIjpbImFkbWluaXN0cmF0b3IiXSwiZmlyc3RfbmFtZSI6Im5ldHdvcmsiLCJsYXN0X25hbWUiOiJvYnNlcnZhYmlsaXR5In0.IXCBa1-9ZskRn2juDQNUZZNh99bkkMTtRx-Aorukn1Y",
      "debugger":{
        "enabled": true,
        "level": "info",
        "accounts":[
          {
            "id": 146,
            "enabled": true,
            "level": "info"
          }
        ]
      }
    }

    const tabItems = [
        {
            id: 1,
            title: 'Basic Info',
            component: <ConfigurationDetails item={config} onClose={onClose} />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'Blacklisted BAPs',
            component: <BlacklistedBAPs />,
            isVisible: true,
        },
        {
            id: 3,
            title: 'Whitelisted Routes',
            component: <WhitelistedRoutes />,
            isVisible: true,
        },
        {
            id: 4,
            title: 'Masked Keywords',
            component: <MaskedKeywords />,
            isVisible: true,
        },
        {
            id: 5,
            title: 'Serviceable Cities',
            component: <ServiceableCities />,
            isVisible: true,
        },
    ];

    const fetchOpenNetworkRegistryById = () => {
        dispatch(openNetworkRegistrations.query({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/open-network-registrations/query`, 
            entity: 'openNetworkRegistrations', 
            jsonData: {
                Records: [
                    {
                        Id: parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleBacicInnerFormChange: any = (event: any, field: string) => {
        setSelectedOpenNetworkRegistry({ ...selectedOpenNetworkRegistry, [field]: event });
    }
    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
          '.',
          field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedOpenNetworkRegistry({ ...selectedOpenNetworkRegistry, [fields[0]]: value });
    }

    useEffect(
        () => {
                if (parmas?.id > 0) {
                    fetchOpenNetworkRegistryById()
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            
        },
        []
    )

    // const parentDomain = openNetworkDomainNameLists?.result?.items.filter(
    //     (subDomainData: any) => subDomainData.IsSubDomain === false
    // )
    // const subDomains = openNetworkDomainNameLists?.result?.items.filter(
    //     (subDomainData: any) => subDomainData.IsSubDomain === true
    // )

    useEffect(
        () => {
            if (isQuery) {
                setSelectedOpenNetworkRegistry(dbnpRegistriesQuery?.result?.items)
            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
    //     event.preventDefault();
    //     if (parmas?.id > 0) {
    //         dispatch(globalOrgRegistrations.update({
    //             url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations`, 
    //             entity: 'globalOrgRegistrations', 
    //             jsonData: {
    //                 Records: [
    //                     selectedDbnpRegistry
    //                 ]
    //             }
    //         })).then(() => {
    //             back()
    //         })
    //     } else {
    //         dispatch(globalOrgRegistrations.create({
    //             url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-org-registrations`, 
    //             entity: 'globalOrgRegistrations', 
    //             jsonData: {
    //                 Records: [
    //                     selectedDbnpRegistry
    //                 ]
    //             }
    //         })).then(() => {
    //             back()
    //         })
    //     }
    }

    useEffect(() => {
        console.log('state', state)
    }, [state]);


    useEffect(() => {
        const tabTitleFromURL = searchParams.get('tab');
        if (tabTitleFromURL) {
            const tabIndex = tabItems.findIndex(tab => tab.title === tabTitleFromURL);
            if (tabIndex !== -1) {
                setSelectedTabIndex(tabIndex);
            }
        } else {
            setSelectedTabIndex(0);
        }
    }, [searchParams]);

    const handleTabChange = (index: number) => {
        setSelectedTabIndex(index);
        setSearchParams({ tab: tabItems[index].title });
    };

    if (selectedTabIndex === null) {
        return null;
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <div className='px-4 pt-4'>
                    <div className="uppercase text-xl py-4">
						{data?.bpp_id}
					</div>
                    <TabContainer
                        tabItems={tabItems}
                        selectedIndex={selectedTabIndex}
                        onChange={handleTabChange}
                    />
                    <div className="flex justify-end mt-2">
                        <button
                            onClick={onClose}
                            type="button"
                            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                        >
                            Close
                        </button>
                        <button
                            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                            onClick={handleFormSubmit}
                            type="submit"
                        >
                            Save
                        </button>
                    </div>
                </div>
            }
        </>
    )

}

export default CommerceBppSetting;